import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {SystemRoleGetSchema} from '../../../../api/DBSchema/SystemRole';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import Sepperator from '../../../../components/Simple/Sepperator';
import ButtonContainer from '../../../../components/Simple/ButtonContainer';
import SMCButton from '../../../../components/Simple/SMCButton';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';

const pageSchema = SystemRoleGetSchema.pages.advanced;
const pageId = pageSchema.pageId;

function SystemRoleGeneral({
    systemRoleObject,
    setSystemRoleData
}) {
    const { t } = useTranslation();

    const pageData = systemRoleObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setSystemRoleData([pageId, paramName], value);
    }, [setSystemRoleData]);

    // Additional permissions
    const isAccessSMPWebUI             = pageData[pageSchema.isAccessSMPWebUI];
    const isEnableLostPasswordRecovery = pageData[pageSchema.isEnableLostPasswordRecovery];
    const isAccessAPI                  = pageData[pageSchema.isAccessAPI];
    const isViewLogs                   = pageData[pageSchema.isViewLogs];
    const isSendEmail                  = pageData[pageSchema.isSendEmail];

    // Ranges
    const ranges       = pageData[pageSchema.ranges];
    const rangesSchema = pageSchema.rangesSchema;

    const [rangesSelected, setRangesSelected] = useState([]);
    const isRangesEnabled = ranges !== null;

    const newRangeOnClick = useCallback(() => {
        const newIpRange = {
            [rangesSchema.startIp]: '',
            [rangesSchema.endIp]: ''
        }
        setPageValue(pageSchema.ranges, [...ranges, newIpRange]);
        setRangesSelected([]);
    }, [ranges, rangesSchema, setPageValue]);

    const deleteRangesOnClick = useCallback(() => {
        if (rangesSelected.length) {
            setPageValue(pageSchema.ranges, ranges.filter((elem, i) => {
                return rangesSelected.indexOf(i) === -1;
            }));
        }
        setRangesSelected([]);
    }, [rangesSelected, ranges, setPageValue]);

    return (
        <EditorLayout>
            <SMCLabel bold>{t('SMP.ROLES.ADVANCED.ADDITIONAL_PERMISSIONS')}</SMCLabel>
            <div style={{ lineHeight: 'normal' }}>
                <SMCCheckbox
                    checked={isAccessSMPWebUI}
                    onChange={e => setPageValue(pageSchema.isAccessSMPWebUI, e.target.checked)}
                    label={t('SMP.ROLES.ADVANCED.ACCESS_SMP_WRBUI')}
                />
                <SMCCheckbox
                    checked={isEnableLostPasswordRecovery}
                    onChange={e => setPageValue(pageSchema.isEnableLostPasswordRecovery, e.target.checked)}
                    label={t('SMP.ROLES.ADVANCED.ENABLE_LOST_RECOVERY')}
                />
                <SMCCheckbox
                    checked={isAccessAPI}
                    onChange={e => setPageValue(pageSchema.isAccessAPI, e.target.checked)}
                    label={t('SMP.ROLES.ADVANCED.ACCESS_API')}
                />
                <SMCCheckbox
                    checked={isViewLogs}
                    onChange={e => setPageValue(pageSchema.isViewLogs, e.target.checked)}
                    label={t('SMP.ROLES.ADVANCED.VIEW_LOGS')}
                />
                <SMCCheckbox
                    checked={isSendEmail}
                    onChange={e => setPageValue(pageSchema.isSendEmail, e.target.checked)}
                    label={t('SMP.ROLES.ADVANCED.SEND_EMAIL')}
                />
            </div>
            <Sepperator />
            <SMCLabel bold>{t('SMP.ROLES.ADVANCED.RESTRICTIONS')}</SMCLabel>
            <SMCCheckbox
                checked={isRangesEnabled}
                onChange={e => {
                    if (!e.target.checked) {
                        setPageValue(pageSchema.ranges, null);
                    } else {
                        setPageValue(pageSchema.ranges, []);
                    }
                }}
                label={t('SMP.ROLES.ADVANCED.LINE1')}
            />
            <ButtonContainer>
                <SMCButton variant="ghost" icon="new" onClick={newRangeOnClick} disabled={!isRangesEnabled}>{t('SMC_GEN_NEW')}</SMCButton>
                <SMCButton variant="ghost" icon="delete" onClick={deleteRangesOnClick} disabled={!rangesSelected.length || !isRangesEnabled}>{t('SMC_GEN_DELETE')}</SMCButton>
            </ButtonContainer>
            {
                ranges && (
                    ranges.map((ipRange, index) => (
                        <RowLayout key={index} spacing={'5px'}>
                            <SMCLabel bold inline>{index+1}</SMCLabel>
                            <SMCCheckbox
                                checked={rangesSelected.includes(index)}
                                onChange={e => {
                                    if (e.target.checked) {
                                        setRangesSelected(selected => [...selected, index]);
                                    } else {
                                        setRangesSelected(selected => selected.filter(i => i !== index));
                                    }
                                }}
                            />
                            <SMCTextInput
                                width={120}
                                value={ipRange[rangesSchema.startIp]}
                                onChange={e => {
                                    const updatedRanges = [...ranges];
                                    updatedRanges[index] = {
                                        ...updatedRanges[index],
                                        [rangesSchema.startIp]: e.target.value
                                    };
                                    setPageValue(pageSchema.ranges, updatedRanges);
                                }}
                            />
                            <span style={{ paddingRight: '4px' }}>-</span>
                            <SMCTextInput
                                width={120}
                                value={ipRange[rangesSchema.endIp]}
                                onChange={e => {
                                    const updatedRanges = [...ranges];
                                    updatedRanges[index] = {
                                        ...updatedRanges[index],
                                        [rangesSchema.endIp]: e.target.value
                                    };
                                    setPageValue(pageSchema.ranges, updatedRanges);
                                }}
                            />
                        </RowLayout>
                    ))
                )
            }
        </EditorLayout>
    )
}

export default SystemRoleGeneral;